
document.addEventListener('DOMContentLoaded', function () {
  const whatsappLink = document.querySelector('.whatsapp-link');

  if (!whatsappLink) return;

  const phone = '919355655578';
  const message = 'Hi Team, I would like to speak to a fashion consultant, can you help?';

  // Mobile devices
  if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    whatsappLink.href =
      'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }
});
